import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { ContentControlDataProtectionExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import { sortByColumn } from './utils/sorters';

export interface ContentControlDataProtectionExclusionFrontendFields extends ContentControlDataProtectionExclusion {
  rulesToConsiderString: string; // only this field is added, because filter is by startsWith
}

export class GzContentControlDataProtectionExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ContentControlDataProtectionExclusion
> {
  sortByColumnMethod(
    a: ContentControlDataProtectionExclusionFrontendFields,
    b: ContentControlDataProtectionExclusionFrontendFields,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.ADDRESS);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(
    items: ContentControlDataProtectionExclusion[]
  ): ContentControlDataProtectionExclusionFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        rulesToConsiderString: item.rulesToConsider.map(rule => rule.ruleName).join(', '),
      };
    });
  }
}
